import { AccessGroup } from '../vas/business-objects/access-group/access-group.model';
import { AccountStatistics } from '../vas/business-objects/account-statistics/account-statistics.model';
import { Account } from '../vas/business-objects/account/account.model';
import { BillingPackage } from '../vas/business-objects/billing-package/billing-package.model';
import { CategoryGroup } from '../vas/business-objects/category-group/category-group.model';
import { ContactType } from '../vas/business-objects/contact-type/contact-type.model';
import { Contact } from '../vas/business-objects/contact/contact.model';
import { ControlType } from '../vas/business-objects/control-type/control-type.model';
import { Control } from '../vas/business-objects/control/control.model';
import { DefaultTask } from '../vas/business-objects/default-task/default-task.model';
import { Field } from '../vas/business-objects/field/field.model';
import { File } from '../vas/business-objects/file/file.model';
import { Form } from '../vas/business-objects/form/form.model';
import { Group } from '../vas/business-objects/group/group.model';
import { JobStatusSummary } from '../vas/business-objects/job-status-summary-item/job-status-summary.model';
import { JobStatus } from '../vas/business-objects/job-status/job-status.model';
import { JobType } from '../vas/business-objects/job-type/job-type.model';
import { Job } from '../vas/business-objects/job/job.model';
import { LookupType } from '../vas/business-objects/lookup-type/lookup-type.model';
import { Lookup } from '../vas/business-objects/lookup/lookup.model';
import { MembershipUser } from '../vas/business-objects/membership-user/membership-user.model';
import { Membership } from '../vas/business-objects/membership/membership.model';
import { Note } from '../vas/business-objects/note/note.model';
import { NotificationTemplate } from '../vas/business-objects/notification-template/notification-template.model';
import { ReportLayout } from '../vas/business-objects/report-layout/report-layout.model';
import { Report } from '../vas/business-objects/report/report.model';
import { SyncUpItemFactory } from '../vas/business-objects/sync-up-item/sync-up-item.factory';
import { TaskType } from '../vas/business-objects/task-type/task-type.model';
import { Task } from '../vas/business-objects/task/task.model';
import { Transition } from '../vas/business-objects/transition/transition.model';
import { User } from '../vas/business-objects/user/user.model';

export const ENTITY_MAP = {
    'accessGroup': AccessGroup,
    'account': Account,
    'accountStatistics': AccountStatistics,
    'billingPackage': BillingPackage,
    'categoryGroup': CategoryGroup,
    'contact': Contact,
    'contactType': ContactType,
    'control': Control,
    'controlType': ControlType,
    'defaultTask': DefaultTask,
    'field': Field,
    'file': File,
    'form': Form,
    'group': Group,
    'job': Job,
    'jobStatus': JobStatus,
    'jobStatusSummary': JobStatusSummary,
    'jobType': JobType,
    'lookup': Lookup,
    'lookupType': LookupType,
    'membership': Membership,
    'membershipUser': MembershipUser,
    'note': Note,
    'notificationTemplate': NotificationTemplate,
    'report': Report,
    'reportLayout': ReportLayout,
    'syncUpItem': {
        factory: data => (SyncUpItemFactory.rehydrate(data))
    },
    'task': Task,
    'taskType': TaskType,
    'transition': Transition,
    'user': User
};



// WEBPACK FOOTER //
// ./src/app/app.config.entity-map.ts